/**
 * The Drameeka mark — ported from the mobile app's `AppLogoIcon`
 * (frontend/src/components/Icons.tsx) so the admin surface shares one real
 * logo instead of inventing a second one. Same two paths, same colors.
 */
export function Logo({ size = 32, className }: { size?: number; className?: string }) {
  return (
    <svg width={size} height={size} viewBox="0 0 36 36" fill="none" className={className}>
      <path
        d="M11 6.5C8.8 5.2 6 6.8 6 9.3v17.4c0 2.5 2.8 4.1 5 2.8l15.1-8.7c2.2-1.3 2.2-4.4 0-5.6L11 6.5z"
        fill="#E11D48"
      />
      <path
        d="M13.5 13C12.7 12.5 11.5 13.1 11.5 14v8c0 0.9 1.2 1.5 2 1l7-4c0.8-0.5 0.8-1.5 0-2l-7-4z"
        fill="#FFFFFF"
      />
    </svg>
  );
}
